import { render, staticRenderFns } from "./CommentReaction.vue?vue&type=template&id=05a27246&"
import script from "./CommentReaction.vue?vue&type=script&lang=js&"
export * from "./CommentReaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports